/**
 * A random RFC 4122 version-4 UUID.
 *
 * `crypto.randomUUID` exists only in secure contexts (HTTPS or localhost).
 * Opening the dev server from a phone over the home network
 * (`http://192.168.x.x`) is not secure, so there the UUID is built from
 * `crypto.getRandomValues`, which every supported browser provides.
 */
export function newUuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()
  return uuidFromRandomBytes(crypto.getRandomValues(new Uint8Array(16)))
}

/** Formats 16 random bytes as a version-4, RFC 4122-variant UUID. */
export function uuidFromRandomBytes(bytes: Uint8Array): string {
  const b = Uint8Array.from(bytes)
  b[6] = ((b[6] ?? 0) & 0x0f) | 0x40
  b[8] = ((b[8] ?? 0) & 0x3f) | 0x80
  const hex = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
